export enum ITEM_LIST {
  // 未支付完成引导
  UNPAID_GUIDE = 'unpaid_guide',
}

/**
 * 未完成支付引导
 */
export function setUnpaidGuideInfo (value: number) {
  sessionStorage.setItem(ITEM_LIST.UNPAID_GUIDE, String(value))
}
export function getUnpaidGuideInfo () {
  return Number(sessionStorage.getItem(ITEM_LIST.UNPAID_GUIDE)) || 0
}
export function removeUnpaidGuideInfo () {
  sessionStorage.removeItem(ITEM_LIST.UNPAID_GUIDE)
}